import { opportunityService } from './OpportunityService'
import type { Opportunity, OpportunityFilters, OpportunityStage, PipelineColumn } from './types'
import { PIPELINE_STAGES, STAGE_LABELS } from './types'
import { round2 } from './storage'

/**
 * PipelineService — Kanban columns and stage transitions.
 */
export class PipelineService {
  build(filters: OpportunityFilters = {}): PipelineColumn[] {
    const items = opportunityService.search(filters)
    return PIPELINE_STAGES.map((stage) => {
      const opportunities = items.filter((o) => o.stage === stage)
      return {
        stage,
        label: STAGE_LABELS[stage],
        opportunities,
        totalValue: round2(opportunities.reduce((sum, o) => sum + o.expectedValue, 0)),
      }
    })
  }

  move(opportunityId: string, stage: OpportunityStage): Opportunity {
    return opportunityService.moveStage(opportunityId, stage)
  }

  cardMeta(opportunity: Opportunity) {
    return {
      customer: opportunity.customerName ?? 'Sem cliente',
      value: opportunity.expectedValue,
      daysIdle: opportunity.daysIdle,
      lastContact: opportunity.lastContact,
      nextContact: opportunity.nextContact,
      stageLabel: STAGE_LABELS[opportunity.stage],
    }
  }
}

export const pipelineService = new PipelineService()
